/* eslint-disable */

import React, { Component } from "react"

import { MAX_LENGTH_QUERYSET_VIZ_CAP, MIDDLE_PURPLE } from "shared/imports/sharedConstants"

import {
    federalRegions,
    stateRegions,
    localRegions,
    federalAndStates,
    usRegions,
    euRegions,
    globalRegions,
} from 'shared/imports/regionConstants'

import genericVisualizationScene, {
    createUSMapScene,
    genericBarPieScene,
    genericLineScene,
    genericMapScene,
    genericNetworkScene,
    genericWordCloudScene,
} from "search-new/containers/Visualization/VisualizationScene/VisualizationScenes"

import { federalMapConfig, euMapConfig, worldMapConfig } from "search-new/components/Visualization/VisualizationWrappers/MapConfigs"

import { RegionFilter, StanceFilter, PriorityFilter } from "shared/search/containers/Filter/Filters"

import { inIssueFilter } from "shared/search/containers/Filter/FilterCreators"

import {
    BillSponsorFilter,
    BillGlobalRegionsFilter,
    BillCosponsorFilter,
    BillSponsorOrCosponsorFilter,
    BillInvisiblePartyFilter,
    BillTypeFilter,
    BillDateAfterFilter,
    BillDateBeforeFilter,
    BillCommitteeFilter,
    BillGeneralStatusFilter,
    BillGlobalStatusFilter,
    BillSupportedRegionsFilter,
} from "shared/search/containers/Filter/BillFilters"

/* *****************************************************************
 * MAPS
 ******************************************************************* */
export const BillMapScene = createUSMapScene({
    uniqueFilterId: BillSupportedRegionsFilter.defaultProps.uniqueFilterId,
    configs: {
        ...federalMapConfig,
        useResourceId: false,
    },
})

export const BillGlobalMapScene = (props) => genericMapScene(props)
BillGlobalMapScene.defaultProps = {
    uniqueVizSceneId: 'billGlobalMapScene',
    filterId: BillGlobalRegionsFilter.defaultProps.uniqueFilterId,
    variableRequestKey: 'regionFrequency',
    label: 'World Map',
    icon: 'fa-globe',
    sidebarTableLabel: 'Bills by Country',
    regions: globalRegions,
    configs: {
        ...worldMapConfig,
        useResourceId: false,
    },
}

/* *****************************************************************
 * BAR / PIE COMBO GRAPHS
 ******************************************************************* */
export class BillOfficialBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "billOfficialBarPieScene",
        // this crazy filter ID is because the filter referenced
        // is a multifilter: we only need the visualization to have
        // access to the Select, not the whole filter
        // (visualizations can't update multifilters yet anyhow)
        filterId: `${BillSponsorOrCosponsorFilter.defaultProps.uniqueFilterId}MultiSelect`,
        variableRequestKey: "personFrequency",
        label: "Sponsors",
        icon: "fa-user",
        regions: usRegions,
        sidebarTableLabel: "Sponsors",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class BillCommitteeBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "billCommitteeBarPieScene",
        filterId: BillCommitteeFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "committeeFrequency",
        label: "Committees",
        icon: "fa-gavel",
        regions: usRegions,
        sidebarTableLabel: "Committees",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class BillPartyBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "billPartyBarPieScene",
        filterId: BillInvisiblePartyFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "partyFrequency",
        label: "Party",
        icon: "fa-check-square-o",
        colorConfigs: {
            secondaryColor: MIDDLE_PURPLE,
            colorFunc: (d, i) => DjangIO.app.person.types.Party.by_value(d.id).color,
        },
        regions: usRegions,
        sidebarTableLabel: "Party Affiliation",
        noOrgDesign: true,
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class BillCoSponsorBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "billCoSponsorBarPieScene",
        filterId: `${BillCosponsorFilter.defaultProps.uniqueFilterId}MultiSelect`,
        variableRequestKey: "cosponsorFrequency",
        label: "Cosponsors",
        icon: "fa-handshake-o",
        regions: usRegions,
        sidebarTableLabel: "Cosponsors",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class BillStateBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "billStateBarPieScene",
        filterId: RegionFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "stateFrequency",
        label: "States",
        icon: "fa-map-marker",
        regions: usRegions,
        sidebarTableLabel: "Bills by State",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class BillTypeBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "billTypeBarPieScene",
        filterId: BillTypeFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "typeFrequency",
        label: "Bill Types",
        icon: "fa-book",
        sidebarTableLabel: "Bills by Type",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export const BillStatusBarPieScene = (props) => genericBarPieScene(props)
BillStatusBarPieScene.defaultProps = {
    uniqueVizSceneId: "billStatusBarPieScene",
    filterId: BillGeneralStatusFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "statusFrequency",
    label: "Status",
    icon: "fa-gavel",
    sidebarTableLabel: "Bills by Status",
}

export const BillGlobalStatusBarPieScene = (props) => genericBarPieScene(props)
BillGlobalStatusBarPieScene.defaultProps = {
    uniqueVizSceneId: 'billGlobalStatusBarPieScene',
    filterId: BillGlobalStatusFilter.defaultProps.uniqueFilterId,
    variableRequestKey: 'globalStatusFrequency',
    label: "Status",
    icon: "fa-gavel",
    sidebarTableLabel: "Bills by Status",
}

export const BillStanceBarPieScene = (props) => genericBarPieScene(props)
BillStanceBarPieScene.defaultProps = {
    uniqueVizSceneId: "billStanceBarPieScene",
    filterId: StanceFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "stanceFrequency",
    label: "Stance",
    icon: "fa-thumbs-o-up",
    sidebarTableLabel: "Bills by Organization Stance",
}

export const BillPriorityBarPieScene = (props) => genericBarPieScene(props)
BillPriorityBarPieScene.defaultProps = {
    uniqueVizSceneId: "billPriorityBarPieScene",
    filterId: PriorityFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "priorityFrequency",
    label: "Priority",
    icon: "fa-arrows-v",
    sidebarTableLabel: "Bills by Organization Priority",
}

export const BillInIssuesBarPieScene = (props) => genericBarPieScene(props)
BillInIssuesBarPieScene.defaultProps = {
    uniqueVizSceneId: "billInIssuesBarPieScene",
    filterId: inIssueFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "inIssueFrequency",
    label: "Issues",
    icon: DjangIO.app.models.QuorumDataType.issue_management.icon,
    sidebarTableLabel: "Bills tagged to Issue",
}

/* *****************************************************************
 * LINE GRAPH (TREND)
 ******************************************************************* */
export class BillTrendsScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "billTrendsScene",
        dateStartId: BillDateAfterFilter.defaultProps.uniqueFilterId,
        dateEndId: BillDateBeforeFilter.defaultProps.uniqueFilterId,
        label: "Trends",
        icon: "fa-line-chart",
    }

    render() {
        return genericLineScene(this.props)
    }
}

/* eslint-enable */
